<div class="flex flex-col flex-auto min-w-0">

    <!-- Header -->
    <div class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-8 sm:px-10 border-b bg-card dark:bg-transparent">
        <div class="flex-1 min-w-0">
            <!-- Title -->
            <div class="mt-2">
                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    {{getDocummentInfo().name}}
                </h2>
            </div>
            <div class="flex flex-col">
                <div *ngIf="getDocummentInfo().description" class="text-md text-hint">{{getDocummentInfo().description}}</div>
                <div *ngIf="getDocummentInfo().version" class="text-md text-hint">{{getDocummentInfo().version}}</div>
            </div>
        </div>
    </div>

    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">
        <div class="w-full">
            <fuse-alert [type]="'info'" (click)="infoVisible=!infoVisible" class="cursor-pointer">
                <span fuseAlertTitle>Informatii completare</span>
                    <ul *ngIf="infoVisible">
                       <li>- Completati campurile cu informatiile cerute, apoi apasati butonul 'Inainte'.</li>
                       <li>- Butonul 'Inainte' se activeaza doar atunci cand datele sunt complete si corecte.</li>
                       <li>- Daca doriti sa reveniti la ecranul anterior, folosit butonul 'Inapoi'.</li>
                       <li>- NU dati 'refresh' (reimprospatare) pagina.</li>
                       <li>- Nu parasaiti pagina pana nu ati completat toate datele.</li>
                    </ul>
            </fuse-alert>

            <mat-divider class="w-full my-4"></mat-divider>

            <!-- Vertical stepper -->
            <ng-container [ngSwitch]="doc_ID">
                <basic-patient-info *ngSwitchCase="DocummentID.BASIC_INF"></basic-patient-info>
                <acord-pacient-informat-sib-v2-wizzard *ngSwitchCase="DocummentID.API_SB_V2"></acord-pacient-informat-sib-v2-wizzard>
                <buletin-informativ-sib-v1-wizzard *ngSwitchCase="DocummentID.BUL_INFO_SB_V1"></buletin-informativ-sib-v1-wizzard>
                <gdpr-sib-v1-wizzard *ngSwitchCase="DocummentID.GDPR_AGREE_SB_V1"></gdpr-sib-v1-wizzard>
            </ng-container>
        </div>

    </div>

</div>
